export default "__VITE_ASSET__D0efK_cq__"